import * as zod from 'zod';

import { CartesianPose } from '@sb/geometry';
import { ArmJointPositions, TCPOffsetOption } from '@sb/motion-planning';

export const Position = zod.object({
  name: zod.string().optional(),
  jointAngles: ArmJointPositions,
  pose: CartesianPose,
  tcpOption: TCPOffsetOption.optional(),
  wristPose: CartesianPose.optional(),
});

export type Position = zod.infer<typeof Position>;

export const PalletBoxType = zod.object({
  id: zod.string(),
  name: zod.string(),
  width: zod.number(),
  height: zod.number(),
  depth: zod.number(),
  weight: zod.number(),
  pickupPosition: Position.optional(),
  pickupPositionWidthOffset: zod.number().optional(),
  pickupPositionDepthOffset: zod.number().optional(),
});

export type PalletBoxType = zod.infer<typeof PalletBoxType>;

export const PalletBoxInstance = zod.object({
  id: zod.string(),
  x: zod.number(),
  y: zod.number(),
  rotation: zod.number(),
  order: zod.number(),
  approachDirection: zod.number(),
});

export type PalletBoxInstance = zod.infer<typeof PalletBoxInstance>;

export const PalletBoxLayerPattern = zod.object({
  id: zod.string(),
  name: zod.string(),
  boxTypeID: zod.string(),
  automaticSequencing: zod.boolean(),
  globalApproachDirection: zod.number(),
  boxList: PalletBoxInstance.array(),
});

export type PalletBoxLayerPattern = zod.infer<typeof PalletBoxLayerPattern>;
